<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2">
        <i class="bi bi-chevron-left align-middle"></i>
      </div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Mi Obra Social / Prepaga</h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-3 mb-0 align-items-center">
      <form (ngSubmit)="saveObraSocial()" [formGroup]="form" novalidate>
        <div class="mb-3 mt-0 text-start form-group">

          <div class="row mt-4">
            <div class="col">
              <label for="obra_social" class="form-label">Obra Social / Prepaga</label>

              <a [routerLink]="['/my-account-obra-social-list']" style="cursor: pointer;">
                <input
                  class="form-control obraSocialSelc"
                  formControlName="obra_social"
                  autocomplete="off"
                  readonly
                  placeholder="Seleccione"
                />
              </a>

              @if (form.controls.obra_social.touched && form.controls.obra_social.errors?.['required']) {
                <div class="alert-danger" role="alert">
                  <small class="alert">La Obra Social es requerida</small>
                </div>
              }
            </div>
          </div>

          <div class="row mt-4">
            <div class="col">
              <label for="obra_social_plan" class="form-label">Plan</label>
              <input type="text" class="form-control" id="obra_social_plan" formControlName="obra_social_plan" />

              @if (form.controls.obra_social_plan.touched && form.controls.obra_social_plan.errors?.['required']) {
                <div class="alert-danger" role="alert">
                  <small class="alert">El Plan es requerido</small>
                </div>
              }
            </div>
          </div>

          <div class="row mt-4">
            <div class="col">
              <div class="col">
                <label for="img_credencial" class="form-label mb-4" style="font-size: 1em;">
                  Credencial de Obra Social / Prepaga
                </label>
              </div>

              @if (preview_img_credencial_obra_social()) {
                <div class="d-inline-block text-center">
                  <div class="credencial-wrapper d-inline-block m-2">
                    <div class="credencial-actions">
                      <div class="credencial-action-icon" (click)="capturarFileImgCredencialObraSocial()">
                        <i class="bi bi-pencil"></i>
                      </div>
                      <div class="credencial-action-icon delete-credential" (click)="eliminarImgCredencialObraSocial()">
                        <i class="bi bi-trash"></i>
                      </div>
                    </div>
                    <img
                      width="100"
                      [src]="preview_img_credencial_obra_social()"
                      class="credencial center-text m-0 p-0 rounded"
                      alt="Credencial" data-bs-toggle="modal" data-bs-target="#modalPreviewImg"
                    />
                  </div>
                </div>
              } @else {
                <div class="row file btn btn-lg btn-primary fileupload rounded-pill m-0 btn-charge-credential"
                     (click)="capturarFileImgCredencialObraSocial()">
                  Cargá la parte frontal de tu credencial
                </div>
              }

              <input
                type="file"
                class="form-control"
                id="img_credencial"
                style="display: none;"
                (change)="capturarFileImgCredencialObraSocial()"
              />

            </div>
          </div>
          <!-- Modal Previw IMG PERFIL :: INICIO -->
        <div class="modal fade" id="modalPreviewImg" tabindex="-1" role="dialog" aria-labelledby="modalPreviewImgLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalPreviewImgLabel">Credencial de Obra Social / Prepaga</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <img [src]="preview_img_credencial_obra_social()" class="img-fluid">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
                </div>
            </div>
        </div>

        <!-- Modal confirmar eliminar imagen -->
        <div class="modal fade" id="modalConfirmarEliminarImagen" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content confirmar-eliminar-content">
              <div class="modal-body text-center pt-4 pb-2">
                <div class="confirmar-eliminar-icono">
                  <i class="bi bi-trash"></i>
                </div>
                <h5 class="mt-3 mb-2">Eliminar imagen</h5>
                <p class="text-muted mb-0">¿Querés eliminar la credencial de Obra Social / Prepaga? Esta acción no se puede deshacer.</p>
              </div>
              <div class="modal-footer border-0 pt-2 pb-4 justify-content-center">
                <button type="button" class="btn btn-outline-secondary rounded-pill px-4" data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-danger rounded-pill px-4" (click)="confirmarEliminarImgCredencialObraSocial()">Eliminar</button>
              </div>
            </div>
          </div>
        </div>

          @if (error()) {
            <div class="alert alert-danger mt-3" role="alert">
              <small>{{ error() }}</small>
            </div>
          }

          <div class="d-grid mt-5 mb-3 pb-3">
            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">
              {{ loading() ? 'Cargando...' : 'Actualizar mis datos' }}
            </button>
          </div>

        </div>
      </form>
    </div>
  </div>
</div>
